import {CommonModule} from '@angular/common';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
    faArrowsRotate,
    faCloud,
    faTriangleExclamation,
    faWifi,
} from '@fortawesome/free-solid-svg-icons';
import {Subscription} from 'rxjs';
import {BusyService} from '../../services/busy.service';
import {SystemState, SystemStateService} from '../../services/system-state.service';

@Component({
    selector: 'app-system-state-panel',
    imports: [CommonModule, FontAwesomeModule],
    templateUrl: './system-state-panel.component.html',
    styleUrl: './system-state-panel.component.css',
})
export class SystemStatePanelComponent implements OnInit, OnDestroy {
    state: SystemState = {type: 'idle'};
    loading = false;
    private subscriptions = new Subscription();

    constructor(
        private systemStateService: SystemStateService,
        private busyService: BusyService,
        library: FaIconLibrary,
    ) {
        library.addIcons(faWifi, faCloud, faTriangleExclamation, faArrowsRotate);
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.systemStateService.state$.subscribe((state) => {
                this.state = state;
            }),
        );
        this.subscriptions.add(
            this.busyService.loading$.subscribe((loading) => {
                this.loading = loading;
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get visible(): boolean {
        return this.loading || this.state.type !== 'idle';
    }

    get title(): string {
        if (this.loading) {
            return 'Loading';
        }
        switch (this.state.type) {
            case 'offline':
                return 'Connection Lost';
            case 'server_unavailable':
                return 'Server Unavailable';
            case 'unexpected_error':
                return 'Unexpected Error';
            default:
                return '';
        }
    }

    get description(): string {
        if (this.loading) {
            return 'Please wait while we fetch the latest data.';
        }
        return this.state.message || '';
    }

    retry(): void {
        this.systemStateService.clear();
        if (typeof window !== 'undefined') {
            window.location.reload();
        }
    }

    dismiss(): void {
        this.systemStateService.clear();
    }
}
